import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  button: {
    id: 'components.PrimaryButtonComponent.button',
    defaultMessage: 'Proszę czekać...'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/PrimaryButtonComponent/PrimaryButtonComponent.intl.js